<div class="animated container-fluid">
    <form class="needs-validation" [formGroup]="form" novalidate>

        <h4 style="display:inline">Validación/Aceptación de la Solicitud de Campaña</h4>
        <h4 style="display:inline">{{ solicitudCam?.Codigo }}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <img *ngIf="solicitudCam?.IdEstadoSolicitudCam" class="estado-icono-big" container="body" src="{{ solicitudCam?.IdEstadoSolicitudCam | IconoEstadoSolicitudCam }}" ngbTooltip="{{ solicitudCam?.EstadoSolicitudCam }}" />
            </span>
        </h5>

        <ng-container *ngIf="estadoSolicitudBorrador">
            <div class="mb-2 nota-info">
                <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> {{ pendienteEnvioMessage }}</label>
            </div>
        </ng-container>

        <div class="pt-2 row">
            <div class="col-md-12">

                <!-- Datos relativos a la Validación -->
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedCabeceraVal = !isCollapsedCabeceraVal" [attr.aria-expanded]="!isCollapsedCabeceraVal" aria-controls="collapseValidacion">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> Detalle de la Validación
                            <i *ngIf="isCollapsedCabeceraVal" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedCabeceraVal" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle" [formGroup]="validacionFormGroup">
                        <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabeceraVal">

                            <div class="row">
                                <div class="form-group col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                    <label class="col-form-label" for="estadoValidacion">Seleccione una opción:</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listOpcionesValidacion"
                                                    formControlName="estadoValidacion"
                                                    (onChange)="onValidaChange($event)"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>
                                <div *ngIf="validacionFormGroup?.getRawValue()?.fechaValidacion" class="form-group col-xl-3 col-lg-6 col-md-2 col-sm-2">
                                    <label class="col-form-label" for="fechaValidacion">Fecha</label>
                                    <p-calendar appendTo="body" formControlName="fechaValidacion" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" [showTime]="true" hourFormat="24"></p-calendar>
                                </div>
                                <div *ngIf="validacionFormGroup?.getRawValue()?.usuarioValidacion" class="form-group col-xl-3 col-lg-6 col-md-3 col-sm-3">
                                    <label class="col-form-label" for="usuarioValidacion">Usuario {{ labelForUserValidacion }}</label>
                                    <input formControlName="usuarioValidacion" name="usuarioValidacion" class="form-control" id="usuarioValidacion" type="text" value="">
                                </div>
                                <div class="form-group col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <label class="col-form-label" for="observacionesValidacion" [ngClass]="{ 'required-field': observacionesValidacionRequired }">Observaciones</label>
                                    <textarea maxlength="300" rows="3" formControlName="observacionesValidacion" name="observacionesValidacion" class="form-control" inputStyleClass="form-control" aria-describedby="validationObservacionesValidacion"></textarea>
                                </div>
                                <div id="validationObservacionesValidacion" class="invalid-feedback d-block" *ngIf="observacionesValidacionRequired">
                                    Obligatorio indicar Observaciones
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Datos relativos a la Aceptación -->
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedCabeceraAcept = !isCollapsedCabeceraAcept" [attr.aria-expanded]="!isCollapsedCabeceraAcept" aria-controls="collapseAceptacion">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> Detalle de la Aceptación
                            <i *ngIf="isCollapsedCabeceraAcept" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedCabeceraAcept" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle" [formGroup]="aceptacionFormGroup">
                        <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabeceraAcept">

                            <div class="row">
                                <div class="form-group col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                    <label class="col-form-label" for="estadoAceptacion">Seleccione una opción:</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listOpcionesAceptacion"
                                                    formControlName="estadoAceptacion"
                                                    (onChange)="onAceptaChange($event)"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>
                                <div *ngIf="aceptacionFormGroup?.getRawValue()?.fechaAceptacion" class="form-group col-xl-3 col-lg-6 col-md-2 col-sm-2">
                                    <label class="col-form-label" for="fechaAceptacion">Fecha</label>
                                    <p-calendar appendTo="body" formControlName="fechaAceptacion" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" [showTime]="true" hourFormat="24"></p-calendar>
                                </div>
                                <div *ngIf="aceptacionFormGroup?.getRawValue()?.usuarioAceptacion" class="form-group col-xl-3 col-lg-6 col-md-2 col-sm-2">
                                    <label class="col-form-label" for="usuarioAceptacion">Usuario Aceptación</label>
                                    <input formControlName="usuarioAceptacion" name="usuarioAceptacion" class="form-control" id="usuarioAceptacion" type="text" value="">
                                </div>
                                <div *ngIf="estadoSolicitudRechazada; else tplEsRechazada" class="form-group col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <div class="nota-info warning">
                                        <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ titleByTipoSolicitud.plural }} no están disponibles en el periodo-campaña de la solicitud.</label>
                                    </div>
                                </div>
                                <ng-template #tplEsRechazada>
                                    <div *ngIf="esRechazada" class="form-group col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                        <div class="nota-info warning">
                                            <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Cuando una solicitud es rechazada, sus {{ titleByTipoSolicitud.plural }} no estarían disponibles en el periodo-campaña de la solicitud.</label>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                            <div class="row">
                                <div class="form-group col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <label class="col-form-label" for="observacionesAceptacion" [ngClass]="{ 'required-field': observacionesAceptacionRequired }">Observaciones</label>
                                    <textarea maxlength="300" rows="3" formControlName="observacionesAceptacion" name="observacionesAceptacion" class="form-control" inputStyleClass="form-control" aria-describedby="validationObservacionesAceptacion"></textarea>
                                </div>
                                <div id="validationObservacionesAceptacion" class="invalid-feedback d-block" *ngIf="observacionesAceptacionRequired">
                                    Obligatorio indicar Observaciones
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </form>

</div>

